import { useNavigation } from 'contexts/NavigationContext'
import { useLanguage } from 'contexts/LanguageContext'
import React, { useEffect, useState } from 'react'
import useTranslation from 'hooks/useTranslation'
import { useAuth } from 'contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import './index.scss'

const NavigationMobile: React.FC = () => {
  const [isClosing, setIsClosing] = useState(false)
  const { isNavigationMobileActive, toggleNavigationMobile } = useNavigation()
  const [isNavigationMobileVisible, setIsNavigationMobileVisible] = useState(false)

  const [language, setLanguage] = useLanguage()
  const { t } = useTranslation('nav')

  const toggleLanguage = () => {
    const newLanguage = language === 'pl' ? 'en' : 'pl'
    setLanguage(newLanguage)
    window.location.reload()
  }

  const navigate = useNavigate()
  const { logOut, isAuth, user } = useAuth()

  useEffect(() => {
    if (isNavigationMobileActive) {
      setIsNavigationMobileVisible(true)
    } else if (!isNavigationMobileActive && isNavigationMobileVisible) {
      setIsClosing(true)
      setTimeout(() => {
        setIsClosing(false)
        setIsNavigationMobileVisible(false)
      }, 500)
    }
  }, [isNavigationMobileActive, isNavigationMobileVisible])

  const clickHandle = (src: string) => {
    navigate(src)
    toggleNavigationMobile()
  }

  return (
    <div className={`navigationMobile ${isNavigationMobileActive ? 'active' : ''} ${isClosing ? 'closing' : ''}`}>
      <div className="bg" onClick={() => toggleNavigationMobile()}></div>
      <div className="wrap">
        <i className="icon icon--close s24" onClick={() => toggleNavigationMobile()}></i>

        <div className="navigationMobile__button" onClick={() => clickHandle('/')}>
          {t('dashboard')}
          <i className="icon icon--back"></i>
        </div>
        <div className="navigationMobile__button" onClick={() => clickHandle('/map')}>
          {t('map')}
          <i className="icon icon--back"></i>
        </div>
        <div className="navigationMobile__button" onClick={() => clickHandle('/qrscanner')}>
          {t('qr_scanner')}
          <i className="icon icon--back"></i>
        </div>
        <div className="divider"></div>
        <div className="navigationMobile__button" onClick={() => clickHandle('/help')}>
          {t('help')}
          <i className="icon icon--back"></i>
        </div>
        <div className="navigationMobile__button" onClick={() => clickHandle('/settings')}>
          {t('account_settings')}
          <i className="icon icon--back"></i>
        </div>

        <div className="divider"></div>
        <div className="navigationMobile__button" onClick={toggleLanguage}>
          {t('language')}: {language === 'pl' ? 'Polski' : 'English'}
          <i className="icon icon--pending"></i>
        </div>

        <div className="navigationMobile__desc">
          <p>{t('no_qr_plate')} <a href="https://mojekondolencje.pl">{t('shop')}</a>, {t('order')} <a href='https://mojekondolencje.pl'>{t('create_profile')}</a> {t('honor_your_loved_one')}</p>
        </div>

        <div className="navigationMobile__login"
          onClick={() => {
            toggleNavigationMobile()
            isAuth
              ? logOut()
              : navigate('/login')
          }}>
          {isAuth ? `${t('logout')}${user?.name ? ': ' + user.name : ''}` : t('login')}
        </div>
      </div>
    </div >
  )
}

export default NavigationMobile